import React, { useState, useEffect } from 'react';
import Title from '../Components/Title';
import Project from '../Components/Project';
import projects from '../data/projects';
import { MainLayout, InnerLayout } from '../Styles/mainLayouts';
import styled from 'styled-components';
import AOS from 'aos';
import 'aos/dist/aos.css';

const ButtonStyled = styled.button`
    outline: none;
    border: none;
    background-color: var(--background-light-color-2);
    padding: .4rem 2rem;
    font-size: inherit;
    color: var(--white-color);
    cursor: pointer;
    transition: all .4s ease-in-out;
    &:active ,&:focus{
        background-color: var(--primary-color);
        color: white;
    }
    &:hover{
        background-color: var(--primary-color);
    }
`;

const ButtonsStyled = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    gap:1rem;
    flex-wrap: wrap;
    width: 100%;
    margin: 2.4rem auto;
`;

const Button = ({ filter, button }) => {
    return (
        <div>
            <ButtonsStyled>
                {button.map((btn, i) => (
                    <ButtonStyled key={i} onClick={() => filter(btn)}>
                        {btn}
                    </ButtonStyled>
                ))}
            </ButtonsStyled>
        </div>
    )
}

const allButtons = ['All', ...new Set(projects.map(item => item.category))]

const ProjectsPage = () => {
    const [menuItem, setMenuItems] = useState(projects);

    const filter = (allButtons) => {
        if (allButtons === 'All') {
            setMenuItems(projects);
            return;
        }
        const filteredData = projects.filter(item => item.category === allButtons);
        setMenuItems(filteredData);
    }

    useEffect(() => {
        AOS.init({ duration: 2500, })
    }, [])

    return (
        <MainLayout id="ProjectsPage">
            <Title title={'Projects'} />
            <InnerLayout data-aos="fade-up">
                <Button filter={filter} button={allButtons} />
                <Project menuItem={menuItem} />
            </InnerLayout>
        </MainLayout>
    )
}
export default ProjectsPage